/*eslint-disable*/
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

// components
import { Button } from '@mui/material'
import { BRAND_OPTIONS } from './login.constants'
import Logo from '../../../../assets/logo.png'
import SelectField from "../../../../components/selectField/LoginSelectField";
import Alert from '../../../../components/Alert/Alert'

// utils
import { applicationAuthClient, janssenApplicationAuthClient } from '../../../../okta/oktaClient'
import { getEnvLabel } from '../../../../helpers/general'
import { useIsMobileView } from '../../../../utils/isMobileView'

// styles
import styles from './login.module.scss'
import { fontSize } from '@mui/system';

const submitStyle = {
  width: '120px',
  fontSize: '11px',
  marginTop: '20px',
  backgroundColor: '#eb1700',
  textTransform: 'none !important',
  '&:hover': {
    backgroundColor: '#CC1400',
  },
  '&:disabled': {
    backgroundColor: 'rgba(102, 90, 71, 0.15) !important',
    color:'#616161',
  },
  '&:focus': {
    backgroundColor: '#CC1400',
  },
}

const oktaAuth = applicationAuthClient

const janssenOktaAuth = janssenApplicationAuthClient

function Login() {
  const { t } = useTranslation()
  const [brand, setBrand] = useState('')
  const isMobile = useIsMobileView()
  const [showMobileAlert, setShowMobileAlert] = useState(true)

  const handleBrandChange = (event) => {
    event?.stopPropagation();
    const { value } = event?.target || {};
    setBrand(value);
    localStorage.setItem('tenant', value)
  }

  const handleLoginClick = () => {
    if(brand === 'GlobalInnovMed') {
      janssenOktaAuth.signInWithRedirect()
    } else {
      oktaAuth.signInWithRedirect()
    }
  }

  const handleAlertClose = () => {
    setShowMobileAlert(false)
  }

  return (
    <div className={styles.signIn}>
      <div>
        <img height="40px" width="200px" src={Logo} alt="Logo" style={{ position: 'relative', top: '-22px' }} />
        <div style={{ paddingLeft: '10px', position: 'relative' }}>
          <hr style={{ position: 'absolute', left: '-210px', width: 'calc(100vw + 210px)', marginLeft: '0', top: '0' }} />
          <div style={{ paddingTop: '18px', paddingRight: '20px' }}>
              {isMobile && showMobileAlert && (
                <Alert
                  alertStyle="warning-alert"
                  headerText={t('not-optimized-for-phone-alert-header')}
                  blurb={t('not-optimized-for-phone-alert')}
                  onClose={handleAlertClose}
                  showClose
                  customStyles={{
                    marginBottom: '20px',
                    width: '100%',
                    fontSize: '14px'
                  }}
                />
              )}
            <h1>{t('welcome-message')}</h1>
          </div>

          <p
            style={{
              fontFamily: 'Johnson Text',
              flexDirection: 'column',
              alignItems: 'flex-start',
              flexShrink: 0,
              fontSize: '14px',
            }}
          >
            {t('welcome-body')}
          </p>
          <div>
            <SelectField
              options={BRAND_OPTIONS}
              label={t('sign-in-blurb')}
              id="brand"
              value={brand}
              error=""
              onChange={handleBrandChange}
              styles={{ width: "300px" }}
            />

            <Button
              className="primary-btn"
              variant="contained"
              type="button"
              disableElevation={true}
              onClick={handleLoginClick}
              sx={{ ...submitStyle }}
              disabled={!brand}
            >
             {t('sign-in')}
            </Button>

          </div>
        </div>
      </div>
    </div>
  )
}
export default Login